<template>
  <Page title="Customizations">
    <div class="customizations-page">
      <TabSwitcher id="c" ref="tabSwitcherRef" :tabs="tabs" />
    </div>
  </Page>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useBeforeUnload } from "@/lib/useBeforeUnload";
import { useStore } from "vuex";

import Page from "@/components/Page.vue";
import TabSwitcher from "@/components/TabSwitcher/TabSwitcher.vue";
import CustomerPortal from "./Tabs/CustomerPortal.vue";
import EmailTab from "./Tabs/Email.vue";
import InvoiceTab from "./Tabs/Invoice.vue";
import ScheduleBoardTab from "./Tabs/ScheduleBoard.vue";
import WidgetTab from "./Tabs/Widget.vue";
import WidgetSetupTab from "./Tabs/WidgetSetup.vue";
import { useTenantCustomizations } from "./useTenantCustomization";

const store = useStore();
const tabSwitcherRef = ref<any>();
const { fetchCustomizationValues } = useTenantCustomizations(true);
useBeforeUnload({
  showConfirmation: () =>
    tabSwitcherRef.value?.getCurrentTabRef()?.hasUnsavedChanges()
});

const tabs = computed(() => {
  return [
    {
      name: "Email",
      ref: "emailTab",
      component: EmailTab,
      beforeTabChange: (ref) => ref.onBeforeTabChange()
    },
    {
      name: "Invoice",
      ref: "invoiceTab",
      component: InvoiceTab
    },
    {
      name: "Customer Portal",
      component: CustomerPortal
    },
    {
      name: "Widget",
      component: WidgetTab
    },
    {
      name: "Widget Setup",
      component: WidgetSetupTab
    },
    {
      name: "Schedule Board",
      component: ScheduleBoardTab
    }
  ].filter((v) => v !== undefined);
});

onMounted(() => {
  fetchCustomizationValues();
});
</script>

<style lang="scss">
.customizations-page {
  .skeleton-bar {
    width: 100%;
    background: #e1e1e1;
    height: 10px;
    border-radius: 50px;
    margin: 5px 0;
    &.white {
      background: #fff;
      width: 58%;
    }
  }
  .color-preview-swatch {
    width: 25px;
    height: 20px;
    margin-right: 5px;
    border-radius: 5px;
  }
  .color-text-input {
    width: 100%;
    height: 35px;
  }
}
</style>
